var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/index.ts
import { isEmpty } from "lodash-es";
import * as Y from "yjs";
var $$PROXY = Symbol("proxy");
var $$TARGET = Symbol("target");
var $$DOC = Symbol("doc");
function isPrimitive(value) {
  return value === void 0 || value === null || typeof value !== "object";
}
function toYObject(val) {
  if (isPrimitive(val))
    return val;
  if (Array.isArray(val)) {
    const yArray = new Y.Array();
    val.forEach((member) => {
      yArray.push([toYObject(member)]);
    });
    return yArray;
  }
  if (val instanceof Y.Array || val instanceof Y.Map) {
    return val;
  }
  const yMap = new Y.Map();
  for (const [key, member] of Object.entries(val)) {
    yMap.set(key, toYObject(member));
  }
  return yMap;
}
function toExistingYObject(val) {
  if (isPrimitive(val))
    return val;
  if ($$TARGET in val && val[$$TARGET])
    return val[$$TARGET];
  return val;
}
var ReadType = /* @__PURE__ */ ((ReadType2) => {
  ReadType2["GET"] = "get";
  ReadType2["HAS"] = "has";
  ReadType2["KEYS"] = "keys";
  return ReadType2;
})(ReadType || {});
var ChangeType = /* @__PURE__ */ ((ChangeType2) => {
  ChangeType2["SET"] = "set";
  ChangeType2["DELETE"] = "delete";
  ChangeType2["ALL"] = "all";
  return ChangeType2;
})(ChangeType || {});
function getProxy(yType, options = { path: [], defaultCtx: {} }) {
  if (isPrimitive(yType)) {
    return yType;
  }
  if (yType[$$PROXY])
    return yType[$$PROXY];
  const proxy = createTypeSpecificProxy(yType, options);
  yType[$$PROXY] = proxy;
  return proxy;
}
function createTypeSpecificProxy(yType, options) {
  if (yType instanceof Y.Array) {
    return createArrayProxy(yType, options);
  }
  return createMapProxy(yType, options);
}
var arrayMethods = Object.getOwnPropertyNames(Array.prototype).reduce(
  (acc, curr) => {
    if (acc[curr] === void 0) {
      acc[curr] = true;
    }
    return acc;
  },
  {
    length: false
  }
);
var symbols = [$$TARGET];
function createArrayProxy(yArray, options) {
  var _a;
  function getNextValue() {
    var _a2, _b, _c, _d;
    if (!((_a2 = yArray._item) == null ? void 0 : _a2.deleted))
      return yArray;
    return (_d = (_c = (_b = yArray._item.next) == null ? void 0 : _b.content) == null ? void 0 : _c.type) != null ? _d : yArray;
  }
  const ctx = __spreadValues({}, options.defaultCtx);
  const { path } = options;
  function splice(start, deleteCount = 0, ...items) {
    var _a2, _b;
    const willInsert = items.length > 0;
    if (deleteCount <= 0 && !willInsert)
      return [];
    let index = start;
    const next = getNextValue();
    if (index < 0) {
      index = Math.max(0, next.length + index);
    } else if (index > next.length) {
      index = next.length;
    }
    const itemsToDelete = [];
    const willDelete = deleteCount > 0 && index < next.length;
    let changeType;
    if (willDelete && willInsert) {
      changeType = "all" /* ALL */;
    } else if (willDelete) {
      changeType = "delete" /* DELETE */;
    } else {
      changeType = "set" /* SET */;
    }
    let cancelled = false;
    (_a2 = options.onBeforeChange) == null ? void 0 : _a2.call(options, {
      item: this,
      path,
      key: start,
      type: changeType,
      ctx,
      cancel: () => {
        cancelled = true;
      },
      get cancelled() {
        return cancelled;
      }
    });
    if (cancelled)
      return [];
    Y.transact(next.doc, () => {
      for (let i = 0; i < deleteCount; i++) {
        if (index + i >= next.length)
          break;
        itemsToDelete.push(getProxy(next.get(index + i), options));
        next.delete(index + i);
      }
      if (items.length) {
        next.insert(index, items.map(toYObject));
      }
    });
    (_b = options.onChange) == null ? void 0 : _b.call(options, {
      item: this,
      path,
      key: start,
      type: changeType,
      ctx
    });
    return itemsToDelete;
  }
  function push(...contents) {
    var _a2;
    const next = getNextValue();
    const initialLength = this.length;
    let cancelled = false;
    (_a2 = options.onBeforeChange) == null ? void 0 : _a2.call(options, {
      item: this,
      path,
      key: null,
      type: "set" /* SET */,
      ctx,
      cancel: () => {
        cancelled = true;
      },
      get cancelled() {
        return cancelled;
      }
    });
    if (cancelled)
      return initialLength;
    next.push(contents.map(toYObject));
    contents.forEach((_, i) => {
      var _a3;
      (_a3 = options.onChange) == null ? void 0 : _a3.call(options, {
        item: this,
        path,
        key: initialLength + i,
        type: "set" /* SET */,
        ctx
      });
    });
    return next.length;
  }
  const toString = () => {
    const next = getNextValue();
    return next.map((item) => {
      var _a2;
      return (_a2 = getProxy(item, options)) == null ? void 0 : _a2.toString();
    }).join(",");
  };
  const arrayProxy = new Proxy([], {
    get(target, key) {
      var _a2, _b;
      const next = getNextValue();
      if (typeof key === "string") {
        if (key === "splice")
          return splice;
        if (key === "push")
          return push;
        if (key === "toString")
          return toString;
        if (arrayMethods[key])
          return Reflect.get(target, key);
        const index = +key;
        if (!Number.isNaN(index)) {
          const value2 = getProxy(next.get(index), __spreadProps(__spreadValues({}, options), {
            path: [...path, key]
          }));
          (_a2 = options.onRead) == null ? void 0 : _a2.call(options, {
            item: target,
            path,
            key,
            type: "get" /* GET */,
            value: value2,
            ctx
          });
          return value2;
        }
      } else {
        return Reflect.get(target, key);
      }
      const value = Reflect.get(next, key);
      (_b = options.onRead) == null ? void 0 : _b.call(options, {
        item: target,
        path,
        key,
        type: "get" /* GET */,
        ctx,
        value
      });
      return Reflect.get(next, key);
    },
    set(target, key, val) {
      var _a2, _b, _c, _d;
      const next = getNextValue();
      if (typeof key === "string") {
        if (key === "length") {
          if (val < next.length) {
            const index2 = next.length - val;
            let cancelled = false;
            (_a2 = options.onBeforeChange) == null ? void 0 : _a2.call(options, {
              item: target,
              path,
              key: index2,
              type: "set" /* SET */,
              ctx,
              cancel: () => {
                cancelled = true;
              },
              get cancelled() {
                return cancelled;
              }
            });
            if (cancelled)
              return true;
            next.delete(val, index2);
            (_b = options.onChange) == null ? void 0 : _b.call(options, {
              item: target,
              path,
              key: index2,
              type: "set" /* SET */,
              ctx
            });
          }
          return true;
        }
        const index = +key;
        if (!Number.isNaN(index)) {
          const current = next.get(index);
          if (current === toExistingYObject(val))
            return true;
          let cancelled = false;
          (_c = options.onBeforeChange) == null ? void 0 : _c.call(options, {
            item: target,
            path,
            key,
            type: "set" /* SET */,
            ctx,
            cancel: () => {
              cancelled = true;
            },
            get cancelled() {
              return cancelled;
            }
          });
          if (cancelled)
            return true;
          (_d = next.doc) == null ? void 0 : _d.transact(() => {
            var _a3;
            if (index < next.length)
              next.delete(index);
            next.insert(index, [toYObject(val)]);
            (_a3 = options.onChange) == null ? void 0 : _a3.call(options, {
              item: target,
              path,
              key,
              type: "set" /* SET */,
              ctx
            });
          });
        }
      } else {
        Reflect.set(target, key, val);
      }
      return true;
    },
    has(target, key) {
      var _a2;
      const next = getNextValue();
      if (typeof key === "string") {
        (_a2 = options.onRead) == null ? void 0 : _a2.call(options, {
          item: target,
          path,
          key,
          type: "has" /* HAS */,
          value: null,
          ctx
        });
        const index = +key;
        if (!Number.isNaN(index)) {
          return index < next.length;
        }
      } else if (symbols.includes(key)) {
        return true;
      }
      return Reflect.has(next, key);
    },
    deleteProperty(target, key) {
      var _a2, _b;
      const next = getNextValue();
      if (typeof key === "string") {
        const index = +key;
        if (!Number.isNaN(index)) {
          let cancelled = false;
          (_a2 = options.onBeforeChange) == null ? void 0 : _a2.call(options, {
            item: target,
            path,
            key,
            type: "delete" /* DELETE */,
            ctx,
            cancel: () => {
              cancelled = true;
            },
            get cancelled() {
              return cancelled;
            }
          });
          if (cancelled)
            return true;
          next.delete(index);
          (_b = options.onChange) == null ? void 0 : _b.call(options, {
            item: target,
            path,
            key,
            type: "delete" /* DELETE */,
            ctx
          });
          return true;
        }
      }
      return Reflect.deleteProperty(yArray, key);
    },
    ownKeys(target) {
      var _a2;
      const next = getNextValue();
      const { length } = next;
      const offset = symbols.length + 1;
      const totalLength = length + offset;
      const keys = Array(totalLength);
      keys[0] = "length";
      symbols.forEach((symbol, i) => {
        keys[i + 1] = symbol;
      });
      for (let i = offset; i < totalLength; i++) {
        keys[i] = `${i - 1}`;
      }
      (_a2 = options.onRead) == null ? void 0 : _a2.call(options, {
        item: target,
        path,
        key: null,
        value: null,
        type: "keys" /* KEYS */,
        ctx
      });
      return keys;
    },
    getOwnPropertyDescriptor(_target, key) {
      const next = getNextValue();
      if (typeof key === "string") {
        if (key === "length") {
          return {
            configurable: false,
            enumerable: false,
            writable: true,
            value: next.length
          };
        }
        const index = +key;
        if (!Number.isNaN(index)) {
          if (index >= next.length) {
            return void 0;
          }
          return {
            configurable: true,
            enumerable: true,
            writable: true,
            value: getProxy(next.get(index), __spreadProps(__spreadValues({}, options), {
              path: [...path, key]
            }))
          };
        }
      } else if (symbols.includes(key)) {
        return {
          configurable: true,
          enumerable: false,
          writable: false,
          value: key
        };
      }
      return Reflect.getOwnPropertyDescriptor(next, key);
    }
  });
  arrayProxy[$$TARGET] = yArray;
  (_a = options.onCreate) == null ? void 0 : _a.call(options, { item: arrayProxy, path, ctx });
  return arrayProxy;
}
function createMapProxy(yMap, options) {
  var _a;
  function getNextValue() {
    var _a2, _b, _c, _d;
    if (!((_a2 = yMap._item) == null ? void 0 : _a2.deleted))
      return yMap;
    return (_d = (_c = (_b = yMap._item.next) == null ? void 0 : _b.content) == null ? void 0 : _c.type) != null ? _d : yMap;
  }
  const ctx = __spreadValues({}, options.defaultCtx);
  const { path } = options;
  const toString = () => "[object Object]";
  const mapProxy = new Proxy(
    {},
    {
      get(target, key) {
        var _a2;
        const next = getNextValue();
        if (typeof key !== "string") {
          return Reflect.get(target, key);
        }
        if (key === "toString") {
          return toString;
        }
        const value = getProxy(next.get(key), __spreadProps(__spreadValues({}, options), {
          path: [...path, key]
        }));
        (_a2 = options.onRead) == null ? void 0 : _a2.call(options, {
          item: target,
          path,
          key,
          value,
          type: "get" /* GET */,
          ctx
        });
        return value;
      },
      set(target, key, val) {
        var _a2, _b;
        const next = getNextValue();
        if (typeof key !== "string") {
          Reflect.set(target, key, val);
          return true;
        }
        const current = next.get(key);
        if (current === toExistingYObject(val))
          return true;
        let cancelled = false;
        (_a2 = options.onBeforeChange) == null ? void 0 : _a2.call(options, {
          item: target,
          path,
          key,
          type: "set" /* SET */,
          ctx,
          cancel: () => {
            cancelled = true;
          },
          get cancelled() {
            return cancelled;
          }
        });
        if (cancelled)
          return true;
        (_b = next.doc) == null ? void 0 : _b.transact(() => {
          var _a3;
          next.set(key, toYObject(val));
          (_a3 = options.onChange) == null ? void 0 : _a3.call(options, {
            item: target,
            path,
            key,
            type: "set" /* SET */,
            ctx
          });
        });
        return true;
      },
      has(target, key) {
        var _a2;
        const next = getNextValue();
        if (typeof key === "string") {
          (_a2 = options.onRead) == null ? void 0 : _a2.call(options, {
            item: target,
            path,
            key,
            type: "has" /* HAS */,
            value: null,
            ctx
          });
          return next.has(key);
        }
        if (key === $$DOC) {
          return Reflect.has(target, $$DOC);
        }
        return symbols.includes(key) || Reflect.has(next, key);
      },
      ownKeys(target) {
        var _a2;
        const next = getNextValue();
        const keys = Array.from(next.keys());
        keys.push(...symbols);
        if (Reflect.has(target, $$DOC))
          keys.push($$DOC);
        (_a2 = options.onRead) == null ? void 0 : _a2.call(options, {
          item: target,
          path,
          key: null,
          value: null,
          type: "keys" /* KEYS */,
          ctx
        });
        return Array.from(next.keys());
      },
      deleteProperty(target, key) {
        var _a2, _b;
        const next = getNextValue();
        if (typeof key === "string") {
          let cancelled = false;
          (_a2 = options.onBeforeChange) == null ? void 0 : _a2.call(options, {
            item: target,
            path,
            key,
            type: "delete" /* DELETE */,
            ctx,
            cancel: () => {
              cancelled = true;
            },
            get cancelled() {
              return cancelled;
            }
          });
          if (cancelled)
            return true;
          next.delete(key);
          (_b = options.onChange) == null ? void 0 : _b.call(options, {
            item: target,
            path,
            key,
            type: "delete" /* DELETE */,
            ctx
          });
          return true;
        }
        return Reflect.deleteProperty(next, key);
      },
      getOwnPropertyDescriptor(_target, key) {
        const next = getNextValue();
        if (typeof key === "string") {
          if (!next.has(key)) {
            return void 0;
          }
          return {
            configurable: true,
            enumerable: true,
            writable: true,
            value: getProxy(next.get(key), __spreadProps(__spreadValues({}, options), {
              path: [...path, key]
            }))
          };
        }
        return Reflect.getOwnPropertyDescriptor(next, key);
      }
    }
  );
  mapProxy[$$TARGET] = yMap;
  (_a = options.onCreate) == null ? void 0 : _a.call(options, { item: mapProxy, path: options.path, ctx });
  return mapProxy;
}
function getDoc(doc) {
  return doc[$$DOC];
}
function createProxyFromDoc(doc, rootKey = "data", type = "map", options) {
  const yRoot = type === "array" ? doc.getArray(rootKey) : doc.getMap(rootKey);
  const root = getProxy(yRoot, __spreadProps(__spreadValues({}, options), {
    path: []
  }));
  root[$$DOC] = doc;
  return root;
}
function createProxiedDoc(data = {}, rootKey = "data", options) {
  const doc = new Y.Doc();
  const yRoot = Array.isArray(data) ? doc.getArray(rootKey) : doc.getMap(rootKey);
  const root = getProxy(yRoot, __spreadProps(__spreadValues({}, options), {
    path: []
  }));
  if (!isEmpty(data)) {
    doc.transact(() => {
      Object.assign(root, data);
    });
  }
  root[$$DOC] = doc;
  return root;
}
function transact2(value, callback) {
  var _a;
  const doc = (_a = value[$$TARGET]) == null ? void 0 : _a.doc;
  if (doc) {
    doc.transact(callback);
  } else {
    callback();
  }
}
export {
  $$DOC,
  $$PROXY,
  $$TARGET,
  ChangeType,
  ReadType,
  createProxiedDoc,
  createProxyFromDoc,
  getDoc,
  getProxy,
  isPrimitive,
  transact2 as transact
};
